import { defineComponent as _defineComponent } from 'vue'
import BaseButton from 'JS/components/BaseButton.vue';
import { BrandLogosWidgetItem } from 'JS/dxp/types/widgets';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { DxpColor, dxpHexColorMap } from 'JS/dxp/types/colors';
import { normalizeTrailingSlash } from 'JS/utilities/url';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandLogosWidgetItem',
  props: {
    item: null,
    showLabel: { type: Boolean },
    size: { default: 'responsive' },
    index: null,
    layout: null
  },
  setup(__props: any) {

const props = __props as { item: BrandLogosWidgetItem, showLabel?: boolean, size: 'small' | 'medium' | 'large' | 'responsive', index: number, layout: string }



const baseBorderColor = dxpHexColorMap[DxpColor.Gray];

const gaDataAttributes = computed(() => createPromoDataAttributes({
	promoId: props.item.link.replace("https://www.farmandfleet.com", ""),
	creativeSlot: `dxp_circle_widget_${props.index + 1}`,
	creativeName: `dxp_circle_widget_${props.layout}`,
	promoName: `${props.item.label}`
}));

const normalizedLink = computed(()=> {
	return normalizeTrailingSlash(props.item.link);
});


return { __sfc: true,props, baseBorderColor, gaDataAttributes, normalizedLink, BaseButton }
}

})